import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericsService } from './generics.service';
import { LoginService } from './login.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Bearer OTA2ZmFlM2Y3MWZiZmM1ZmRhMWEzYThmODdiNzU4ODE='
  })
};

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private generics: GenericsService,
              private loginServ: LoginService) { }

  salvarTemplate(form:any) {
      return this.generics.post('templateProjeto', JSON.stringify(form));
  }

  getTemplateByUsuarioTipoProjeto(tipoProjeto:string) {
    return this.generics.get('templateProjeto/' + this.loginServ.getUsuario("id") + '/' + tipoProjeto);
  }

  getModelos() {
    return this.generics.get('templateProjeto/usuario/' + this.loginServ.getUsuario("id"));
  }

  getSugestao(tipo:string) {
    return this.generics.get('templateProjeto/sugestao/' + tipo);  
  }

}
